import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const SessionLogService = sdk.getService('SessionLogService');

export const useLastConnection = (userId: string) => {
  const { data: lastConnection, isLoading } = useQuery({
    queryKey: ['session-logs', 'last-connection', userId],
    queryFn: () => SessionLogService.getLastConnection(userId),
    enabled: Boolean(userId)
  });

  return {
    lastConnection,
    isLoading
  };
};
